import { REHYDRATE } from 'redux-persist';
import { COMPANY_CREATE_ERROR, COMPANY_REQUEST_ERROR, COMPANY_UPDATE_ERROR } from 'features/company/companyActions';
import { REQUEST_COMPANY_INVOICES_ERROR } from 'features/invoices/invoiceActions';
import { CREATE_PAYMENT_METHOD_ERROR, UPDATE_PAYMENT_METHOD_ERROR } from 'features/paymentmethods/paymentMethodActions';
import { REQUEST_COMPANY_TELEMATIC_ACCOUNTS_ERROR } from 'features/telematics/telematicAccountsActions';
import { COMPANY_VEHICLES_REQUEST_ERROR, COMPANY_VEHICLE_CREATE_ERROR } from 'features/vehicles/vehiclesActions';
import { SEND_MESSAGE_TO_SUPPORT_ERROR } from 'features/support/feedbackActions';
import { SEND_FEEDBACK_TO_SUPPORT_ERROR } from 'features/support/feedbackActions';
import { VALIDATE_ENTERED_LICENSE_PLATES_ERROR } from 'features/vehicles/importVehiclesActions';
import { IMPORT_VALID_LICENSE_PLATES_ERROR } from 'features/vehicles/importVehiclesActions';
import * as Sentry from '@sentry/react';
import { AnyAction } from 'redux';
import { userSlice } from 'features/user/userSlice';


let defaultState = {
    error: null,
};

export default function globalErrorReducer(state = defaultState, action: AnyAction) {
    switch (action.type) {
        case 'CLEAR_ERROR_MODAL':
            // RESET ERROR MODAL
            // XXX_START:

            return {
                error: null,
            };

        //======================================================================================================
        // SHOW GLOBAL ERROR POPUP FOR THESE ACTIONS
        //======================================================================================================

        //case USER_CREATE_ERROR:
        case userSlice.actions.createUserError.type:

        case COMPANY_CREATE_ERROR:
        case COMPANY_VEHICLE_CREATE_ERROR:
        case CREATE_PAYMENT_METHOD_ERROR:
        case COMPANY_REQUEST_ERROR:
        case COMPANY_UPDATE_ERROR:
        case UPDATE_PAYMENT_METHOD_ERROR:
        case REQUEST_COMPANY_INVOICES_ERROR:
        case REQUEST_COMPANY_TELEMATIC_ACCOUNTS_ERROR:
        case COMPANY_VEHICLES_REQUEST_ERROR:
        case SEND_MESSAGE_TO_SUPPORT_ERROR:
        case SEND_FEEDBACK_TO_SUPPORT_ERROR:
        case VALIDATE_ENTERED_LICENSE_PLATES_ERROR:
        case IMPORT_VALID_LICENSE_PLATES_ERROR:
            const actionType = action.type ?? 'UNKNOWN_ACTION_TYPE';

            console.error('GLOBAL_ERROR_REDUCER:', action.error);
            Sentry.setContext('error', action.error);
            Sentry.setContext('error-action-type', { type: action.type });
            Sentry.captureMessage(`GLOBAL_ERROR_REDUCER | ${actionType}`);
            // TODO: ignore if already catched localy (seperate or remove these actions)
            // show popup ?
            return {
                error: action.error,
            };

        //======================================================================================================

        case REHYDRATE:
            return {
                ...state,
            };

        default:
            return state;
    }
}
